<template>
  <a-modal
    class="info-dialog"
    title="下载详情"
    width="1000px"
    v-model:visible="visible"
    :footer="false">
    <a-tabs>
      <a-tab-pane key="1" tab="基本信息">
        <a-form class="info-dialog-form">
          <a-form-item label="名称">
            <a-input v-if="editing" v-model:value="form.createName" autocomplete="off"></a-input>
            <span v-else>{{ form.createName }}</span>
          </a-form-item>
          <a-form-item label="描述">
            <a-input v-if="editing" v-model:value="form.createDescription" autocomplete="off"></a-input>
            <span v-else>{{ form.createDescription }}</span>
          </a-form-item>
          <a-form-item label="原因">
            <a-input v-if="editing" v-model:value="form.createNote" autocomplete="off"></a-input>
            <span v-else>{{ form.createNote }}</span>
          </a-form-item>
          <a-form-item label="下载包ID">
            <span>{{ currentItem.id }}</span>
          </a-form-item>
          <a-form-item label="创建人">
            <span>{{ getUserName(currentItem.createUserId) }}</span>
          </a-form-item>
          <a-form-item label="创建时间">
            <span>{{ getDateTime(currentItem.createTime) }}</span>
          </a-form-item>
          <a-form-item label="数据量">
            <span>{{ total }}</span>
          </a-form-item>
          <a-form-item label="包大小" v-if="currentItem.type == 'zip'">
            <span>{{ getPakageSize(currentItem.dealDetail) }}</span>
          </a-form-item>
          <a-form-item label="下载方式">
            <span>{{ getPakageType(currentItem.type) }}</span>
          </a-form-item>
          <a-form-item label="导出位置" v-if="currentItem.type == 'copy'">
            <span>{{ currentItem.targetPath }}</span>
          </a-form-item>
        </a-form>
        <div class="ctrl-wrap" v-if="btnPerm.dataset.edit.indexOf(currentRole.roleId) !== -1">
          <a-button v-if="!editing" type="primary" @click="editing = true">编辑</a-button>
          <a-button v-if="editing" type="primary" @click="submit">保存</a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="图片列表" forceRender>
        <PicList ref="picList"
          :datasetId="currentItem.datasetId"
          @settotal="setTotalCount"></PicList>
      </a-tab-pane>
    </a-tabs>
    <a-table
      style="margin-top:10px;"
      class="download-record"
      :columns="recordColumn"
      :data-source="recordData"
      rowKey="id"
      :pagination="false">
      <template v-slot:time="{ text }">
        {{ getDateTime(text) }}
      </template>
      <template v-slot:createUserId="{ text }">
        {{ getUserName(text) }}
      </template>
    </a-table>
    <br>
    <a-pagination
      :current="recordPage"
      show-quick-jumper
      :pageSize="10"
      :total="recordTotal"
      :show-total="total => `共 ${recordTotal} 条下载记录`"
      @change="getRecord"
    ></a-pagination>
  </a-modal>
</template>
<script>
import PicList from '../DataSet/PicList'
import { mapState } from 'vuex'
import { getDateTime, getUserName } from '@/filters'
import { updatePakage, getDownloadByPage } from '@/api/dataDownload'
import config from '@/config'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    PicList
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      visible: false,
      editing: false,
      form: {
        createName: '', // 名称 可编辑
        createDescription: '',
        createNote: ''
      },
      dataList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      recordColumn: [
        {
          title: '下载人',
          dataIndex: 'createUserId',
          slots: { customRender: 'createUserId' }
        },
        {
          title: '下载时间',
          dataIndex: 'createTime',
          slots: { customRender: 'time' }
        },
        {
          title: '下载原因',
          dataIndex: 'createNote'
        }
      ],
      recordData: [],
      recordPage: 1,
      recordTotal: 0
    }
  },
  computed: {
    ...mapState(['appConfig', 'currentRole'])
  },
  methods: {
    getDateTime,
    getUserName,
    setTotalCount (e) {
      this.total = e
    },
    getPakageType(str){
      let result = ''
      if(str == 'copy'){
        result = '导出至存储'
      }
      if(str == 'zip'){
        result = '下载包'
      }
      return result
    },
    getPakageSize (str) {
      if (str) {
        const arr = str.split(' MB')
        return arr[0] ? arr[0] + 'MB' : ''
      } else {
        return ''
      }
    },
    open () {
      this.visible = true
      this.editing = false
      this.dataList = []
      this.$nextTick(() => {
        this.form.createName = this.currentItem.createName
        this.form.createDescription = this.currentItem.createDescription
        this.form.createNote = this.currentItem.createNote
        this.getRecord()
        this.$nextTick(() => {
          this.$refs.picList.reset()
        })
      })
    },
    submit () {
      const params = {
        id: this.currentItem.id,
        createName: this.form.createName,
        createDescription: this.form.createDescription,
        createNote: this.form.createNote
      }
      updatePakage(params).then(res => {
        this.$message.success('已保存')
        this.$emit('update')
        this.visible = false
      }).catch(err => {
        this.$message.error(err.response.data.message)
      })
    },
    getRecord (pageNum) {
      if (pageNum) this.recordPage = pageNum
      getDownloadByPage({
        pageNum: this.recordPage,
        pageSize: 10,
        pakageRecordId: this.currentItem.id
      }).then(res => {
        const data = res.data.map.data
        this.recordTotal = data.total
        this.recordData = data.rows
      })
    }
  }
}
</script>
<style lang="less">
.info-dialog {
  .info-dialog-form {
    display: flex; flex-wrap: wrap;
    .ant-form-item {
      margin: 0 0 10px;
      width: 50%;
    }
  }
  .ctrl-wrap {
    text-align: right;
  }
  .pic-wrap {
    display: flex; flex-wrap: wrap;
    .pic-item {
      padding: 10px; box-sizing: border-box;
      width: 20%; text-align: center;
      img {
        width: 100%; height: 120px;
      }
    }
  }
}
</style>
